__turbopack_context__.v({
  "pillsWrapper": "styles-module__F_UjYG__pillsWrapper" + " " + "styles-module__F_UjYG__placeholderContainer",
  "placeholderContainer": "styles-module__F_UjYG__placeholderContainer",
  "titlePlaceholder": "styles-module__F_UjYG__titlePlaceholder",
});
